import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

import { UpdateCardService } from './update-card.service';

@Component({
  selector: 'update-card',
  template: require('./update-card.component.html'),
  styles: [require('./update-card.component.scss')],
  providers: [UpdateCardService]
})
export class UpdateCardComponent implements OnInit {

  @Input()
  set display(toDisplay: boolean) {
    this.service.show = toDisplay;
  }

  @Output() onClose = new EventEmitter<boolean>();
  close() {
    this.onClose.emit(true);
  }

  constructor(private service: UpdateCardService) {
  }

  ngOnInit() {
    this.service.errors.update = '';
  }
}



// WEBPACK FOOTER //
// ./node_modules/angular-router-loader/src!./node_modules/angular2-template-loader!./node_modules/@angularclass/hmr-loader!./node_modules/tslint-loader!./src/app/account/update-card/update-card.component.ts